var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 39,
    viewBox: "0 0 47 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medical logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4621_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4622_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14991_",
    d: "M22.442 29.19C22.1207 29.19 21.8086 29.017 21.6434 28.6609L15.7592 12.455L10.1963 20.0341C10.0402 20.207 9.875 20.3901 9.56289 20.3901H4.79863C4.32129 20.3901 4 20.0341 4 19.505C4 18.976 4.32129 18.62 4.79863 18.62H9.25078L15.291 10.166C15.4471 9.99309 15.7684 9.80997 16.0896 9.80997C16.4109 9.80997 16.567 9.98291 16.723 10.339L22.1299 25.4869L23.0846 21.0819C23.2406 20.7258 23.5619 20.3799 23.8832 20.3799H24.8379L27.858 10.339C28.0141 9.98291 28.1793 9.80997 28.6566 9.80997C28.9779 9.80997 29.29 9.98291 29.4553 10.339L35.0182 25.843L37.4049 19.149C37.5609 18.7929 37.8822 18.62 38.2035 18.62H39.7916C40.2689 18.62 40.5902 18.976 40.5902 19.505C40.5902 20.0341 40.2689 20.3901 39.7916 20.3901H38.6809L35.982 28.4982C35.6607 29.2001 34.7061 29.2001 34.55 28.4982L28.8311 13.1773L26.4443 21.4583C26.2883 21.8144 25.967 21.9873 25.6457 21.9873H24.691L23.259 28.5083C23.0754 28.8441 22.7541 29.017 22.442 29.19Z",
    fill: "#FFFEFE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4623_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4624_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14990_",
    d: "M38.9746 16.86C38.8186 16.86 38.6533 16.86 38.6533 16.6871C38.332 16.5141 38.176 15.9851 38.332 15.4561C38.9654 14.2252 39.2867 12.8111 39.2867 11.4072C39.2867 6.47316 35.7893 2.59717 31.3371 2.59717C26.885 2.59717 23.3875 6.47316 23.3875 11.4072C23.3875 11.9362 23.0662 12.2922 22.5889 12.2922C22.1115 12.2922 21.7902 11.9362 21.7902 11.4072C21.7902 6.47316 18.2928 2.59717 13.8406 2.59717C9.38848 2.59717 5.89102 6.47316 5.89102 11.4072C5.89102 12.8213 6.2123 14.2252 6.8457 15.4561C7.00176 15.8122 6.8457 16.3412 6.52441 16.6871C6.20312 16.86 5.72578 16.6871 5.41367 16.331C4.45898 14.744 4.1377 13.157 4.1377 11.5699C4.1377 5.76104 8.43379 0.999969 13.6754 0.999969C17.6502 0.999969 20.9916 3.64501 22.4145 7.33789C23.8465 3.63483 27.1787 0.999969 31.1535 0.999969C36.3951 0.999969 40.6912 5.76104 40.6912 11.5699C40.6912 13.3299 40.3699 14.9169 39.5805 16.331C39.608 16.6871 39.2867 16.86 38.9746 16.86Z",
    fill: "#FFFEFE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4625_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14989_",
    d: "M22.4419 38C22.2859 38 21.9646 37.8271 21.8085 37.6439L10.6736 23.554C10.3523 23.198 10.3523 22.669 10.6736 22.3231C10.9949 21.967 11.4722 21.967 11.7843 22.3231L22.2767 35.711L30.3824 24.9681C30.7037 24.6121 31.181 24.6121 31.4931 24.7952C31.8144 25.1512 31.8144 25.6802 31.6492 26.0261L22.9101 37.4812C22.9193 37.8271 22.598 37.8271 22.4419 38Z",
    fill: "#FFFEFE"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalLogo);
export default __webpack_public_path__ + "static/media/Medical_logo.d9cacd6482a7e7e59a7ebc0e8faf7f9c.svg";
export { ForwardRef as ReactComponent };